import React from 'react';
import { useIntl } from 'react-intl';
import { useFormContext, useWatch } from 'react-hook-form';
import CustomCheckbox from '../../../../../../generic/CustomCheckbox';
import CustomTextarea from '../../../../../../generic/CustomTextarea';
import './LandInformation.scss';
import { upNumberString } from '../../../../../../utils/helpers';

const LandInformation = ({ defaultValues, tabKey, isActiveTab, disabled }) => {
  const translate = useIntl();
  const { register, errors } = useFormContext();
  const { [tabKey]: formErrors } = errors;

  const isTrueString = (s) => s === 'true';

  const watchWasProjectZoneCleared = useWatch({ name: `${tabKey}.wasProjectZoneCleared`, exact: true });
  const watchCommerciallyUsed = useWatch({ name: `${tabKey}.commerciallyUsed`, exact: true });
  const isBeDisplaced = Object.hasOwn(defaultValues, 'beDisplaced');
  return (
    <div className="land-info__wrapper" style={{ display: isActiveTab ? 'block' : 'none' }}>
      <div className="land-info">
        <div className="land-info__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.whoOwnsTheLand' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.whoOwnsTheLand`}
            value={defaultValues.whoOwnsTheLand}
            register={register({ required: true })}
            error={formErrors?.whoOwnsTheLand}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.landUseOfProjectZone' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.landUseOfProjectZone`}
            value={defaultValues.landUseOfProjectZone}
            register={register({ required: true })}
            error={formErrors?.landUseOfProjectZone}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <div>
            <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.wasProjectZoneCleared' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.wasProjectZoneCleared`}
                defaultChecked={isTrueString(defaultValues.wasProjectZoneCleared)}
                register={register({ required: true })}
                error={formErrors?.wasProjectZoneCleared}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.wasProjectZoneCleared`}
                defaultChecked={isTrueString(defaultValues.wasProjectZoneCleared)}
                register={register({ required: true })}
                error={formErrors?.wasProjectZoneCleared}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.howLandWasCleared' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.howLandWasCleared`}
            value={defaultValues.howLandWasCleared}
            register={register({ required: isTrueString(watchWasProjectZoneCleared) })}
            error={formErrors?.howLandWasCleared}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.currentLandUse' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.currentLandUse`}
            value={defaultValues.currentLandUse}
            register={register({ required: true })}
            error={formErrors?.currentLandUse}
            disabled={disabled}
          />
        </div>

        <div className="land-info__item">
          <div>
            <p className="form-field-title">{isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.commerciallyUsed' }), 0.1) : translate.formatMessage({ id: 'carbon.form.commerciallyUsed2' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.commerciallyUsed`}
                defaultChecked={isTrueString(defaultValues.commerciallyUsed)}
                register={register({ required: true })}
                error={formErrors?.commerciallyUsed}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.commerciallyUsed`}
                defaultChecked={isTrueString(defaultValues.commerciallyUsed)}
                register={register({ required: true })}
                error={formErrors?.commerciallyUsed}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="land-info__item">
          <CustomTextarea
            label={isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.howZoneIsUsedByCommunities' }), 0.1) : translate.formatMessage({ id: 'carbon.form.howZoneIsUsedByCommunities2' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.howZoneIsUsedByCommunities`}
            value={defaultValues.howZoneIsUsedByCommunities}
            register={register({ required: isTrueString(watchCommerciallyUsed) })}
            error={formErrors?.howZoneIsUsedByCommunities}
            disabled={disabled}
          />
        </div>
        {isBeDisplaced && (
          <div className="land-info__item">
            <CustomTextarea
              label={translate.formatMessage({ id: 'carbon.form.beDisplaced' })}
              placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
              classTextarea="textarea-field"
              customClassLabel="form-field-title"
              name={`${tabKey}.beDisplaced`}
              value={defaultValues.beDisplaced}
              register={register({ required: true })}
              error={formErrors?.beDisplaced}
              disabled={disabled}
            />
          </div>
        )}
        <div className="land-info__item">
          <CustomTextarea
            label={isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.involvementInLivelihoodsPrograms' }), 0.1) : translate.formatMessage({ id: 'carbon.form.involvementInLivelihoodsPrograms' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.involvementInLivelihoodsPrograms`}
            value={defaultValues.involvementInLivelihoodsPrograms}
            register={register({ required: true })}
            error={formErrors?.involvementInLivelihoodsPrograms}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.engagedInAlternativeOptions' }), 0.10, '3.10') : translate.formatMessage({ id: 'carbon.form.engagedInAlternativeOptions' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.engagedInAlternativeOptions`}
            value={defaultValues.engagedInAlternativeOptions}
            register={register({ required: false })}
            error={formErrors?.engagedInAlternativeOptions}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.landUseIfZoneNotImplemented' })) : translate.formatMessage({ id: 'carbon.form.landUseIfZoneNotImplemented' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.landUseIfZoneNotImplemented`}
            value={defaultValues.landUseIfZoneNotImplemented}
            register={register({ required: true })}
            error={formErrors?.landUseIfZoneNotImplemented}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <CustomTextarea
            label={isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.isLocatedOnPeatlandsOrWetlands' })) : translate.formatMessage({ id: 'carbon.form.isLocatedOnPeatlandsOrWetlands' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.isLocatedOnPeatlandsOrWetlands`}
            value={defaultValues.isLocatedOnPeatlandsOrWetlands}
            register={register({ required: true })}
            error={formErrors?.isLocatedOnPeatlandsOrWetlands}
            disabled={disabled}
          />
        </div>
        <div className="land-info__item">
          <div>
            <p className="form-field-title">{isBeDisplaced ? upNumberString(translate.formatMessage({ id: 'carbon.form.includeExistingScatteredTrees' })) : translate.formatMessage({ id: 'carbon.form.includeExistingScatteredTrees' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.includeExistingScatteredTrees`}
                defaultChecked={isTrueString(defaultValues.includeExistingScatteredTrees)}
                register={register({ required: true })}
                error={formErrors?.includeExistingScatteredTrees}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.includeExistingScatteredTrees`}
                defaultChecked={isTrueString(defaultValues.includeExistingScatteredTrees)}
                register={register({ required: true })}
                error={formErrors?.includeExistingScatteredTrees}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandInformation;
